// extracted by mini-css-extract-plugin
export default {"title":"index_title_EixGK","clockico":"index_clockico_ZWr18","updatetext":"index_updatetext_Vk-zZ","timespan":"index_timespan_-izyX"};